import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Except } from "type-fest";
import { z } from "zod";
import { generateId } from "../../../../utilities/generate-id";
import { idZodSchema } from "../../../id";
import type { Password} from "../../../password";
import { passwordZodSchema } from "../../../password";

type ClassicSignInCommand = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "CLASSIC_SIGN_IN_COMMAND";
    readonly username: string;
    readonly password: Password;
};

type FactoryParams = Except<
    ClassicSignInCommand,
    "_id" | "_type" | "_createdAt"
>;
const classicSignInCommandFactory = (params: FactoryParams) => {
    const classicSignInCommand: ClassicSignInCommand = {
        ...params,
        _id: generateId({ prefix: "classic_sign_in_command__" }),
        _type: "CLASSIC_SIGN_IN_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return classicSignInCommand;
};

const classicSignInCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("CLASSIC_SIGN_IN_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    username: z.string().min(5),
    password: passwordZodSchema,
});

export { classicSignInCommandFactory, classicSignInCommandZodSchema };
export type {
    ClassicSignInCommand,
    FactoryParams as ClassicSignInCommandFactoryParams,
};
